import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { withTranslate } from 'shared/hocs/withTranslate';
import { withFetch } from 'shared/hocs/withFetch';
import { InputText, InputPhoneNumber, Button } from 'shared/components/UI';
import { isValidPhone } from 'shared/validations/validations';

import { sandEmail } from './service';
import s from './DealerServiceForm.css';

class DealerServiceForm extends React.Component {
  static propTypes = {
    onSent: PropTypes.func,
    service: PropTypes.string.isRequired,
    dealerSlug: PropTypes.string.isRequired,
    advertInfo: PropTypes.shape(),
    t: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    user: PropTypes.shape(),
  };

  static defaultProps = {
    onSent: () => {},
    advertInfo: null,
    user: null,
  };

  constructor(props) {
    super(props);
    const { user } = this.props;
    const userName = (user && user.name) || '';
    const phone = (user && user.phones && user.phones[0].number) || '';

    this.state = {
      phone,
      name: userName,
      errorMessage: '',
      successMessage: '',
      disabled: !(phone && phone.length && userName && userName.length),
    };
  }

  validateForm = () => {
    const { phone } = this.state;
    if (phone && !isValidPhone(phone.replace(/\s/g, ''))) {
      this.setState({
        errorMessage: this.props.t('Некорректный номер телефона'),
      });
      return false;
    }
    return !!phone;
  };

  handleInput = (field, value) => {
    this.setState({
      [field]: value,
      errorMessage: '',
      disabled: !this.state.phone || !this.state.name,
    });
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;
    const { dealerSlug, service, advertInfo } = this.props;
    const { phone, name } = this.state;
    const dataToEmail = {
      slug: dealerSlug,
      service,
      phone,
      name,
    };

    if (advertInfo && advertInfo.advertId) {
      dataToEmail.advertId = advertInfo.advertId;
    }

    this.setState({ disabled: true });
    const errMsg = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';
    sandEmail(dataToEmail, this.props.fetch)
      .then(data => {
        this.setState({ disabled: false });
        if (data) this.props.onSent();
        else if (!data) this.setState({ errorMessage: errMsg });
      })
      .catch(() => {
        this.setState({
          disabled: false,
          errorMessage: errMsg,
        });
      });
  };

  render() {
    const { errorMessage, successMessage, name, phone, disabled } = this.state;
    const { t } = this.props;

    return (
      <div className={s.root}>
        <form className={s.requestForm}>
          <InputPhoneNumber
            name={'phone'}
            value={phone}
            changeHandler={(field, value) => this.handleInput(field, value)}
          />
          <InputText
            name={'name'}
            value={name}
            placeholder={name || t('Введите имя')}
            changeHandler={(field, value) => this.handleInput(field, value)}
          />
          <Button
            type="button"
            text={t('Подтвердить номер')}
            disabled={disabled}
            onClick={e => {
              this.handleSubmit(e);
            }}
          />
        </form>
        {(errorMessage || successMessage) && (
          <span
            className={cx(
              { [s.errorMessage]: errorMessage },
              { [s.successMessage]: successMessage },
            )}
          >
            {t(errorMessage || successMessage)}
          </span>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user && state.user.user,
});

export default withStyles(s)(
  withFetch(
    connect(
      mapStateToProps,
      null,
    )(withTranslate(DealerServiceForm)),
  ),
);



// WEBPACK FOOTER //
// ./src/shared/components/DealerServiceForm/DealerServiceForm.js